import { checkbox } from '@tecsinapse/cortex-core'
import { LiaFolderOpenSolid } from 'react-icons/lia'
import { FaRegFileAlt } from 'react-icons/fa'
import { IoIosArrowForward } from 'react-icons/io'
import React from 'react'
import { createColumnHelper } from '@tanstack/react-table'
import { ItemBiblioteca } from '@/core/types/graphql'
import { ColumnsProps } from '../types/types'

const columnHelper = createColumnHelper<ItemBiblioteca>()

export const columnsBuscaArquivos = ({
  isItemSelected,
  selectedRows,
  onClickItem
}: ColumnsProps) => {
  return [
    columnHelper.display({
      id: 'check',
      cell: ({ row: { original: pasta } }) => {
        return (
          <input
            className={checkbox({ className: 'w-fit' })}
            type='checkbox'
            checked={isItemSelected(selectedRows, pasta.id)}
            onChange={() => onClickItem(pasta)}
          />
        )
      }
    }),
    columnHelper.display({
      id: 'nome',
      cell: ({ row: { original: item } }) => {
        return (
          <div className='flex flex-row space-x-micro items-center w-fit'>
            {item.isPasta ? (
              <LiaFolderOpenSolid className='text-primary-medium' />
            ) : (
              <FaRegFileAlt className={'text-primary-medium'} />
            )}
            <p>{item.nome}</p>
          </div>
        )
      }
    }),
    columnHelper.display({
      id: 'breadcrumbs',
      cell: ({ row: { original: item } }) => {
        const breadcrumbs = [...(item?.breadcrumb ?? [])]
        const listaPastas = breadcrumbs.map(bread => bread?.nome)

        if (!item.isPasta) {
          listaPastas.pop()
        }

        return (
          <div className='flex flex-row space-x-micro items-center w-fit mb-deca'>
            {listaPastas.map((nome, idx) => {
              return (
                <div
                  className={'flex flex-row items-center space-x-micro '}
                  key={idx}
                >
                  <div className={'flex flex-row items-center space-x-micro '}>
                    <LiaFolderOpenSolid className='text-primary-medium' />
                    <p>{nome}</p>
                  </div>
                  {idx !== listaPastas.length - 1 ? (
                    <IoIosArrowForward />
                  ) : (
                    <></>
                  )}
                </div>
              )
            })}
          </div>
        )
      }
    })
  ]
}
